import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pipeline: [],
  pipelineMap: {},
  pipelineMobile: [],
  pipelineMobileMap: {},
  sitePipelineCountMap: {},
  loading: false
};

export const pipelineSlice = createSlice({
  name: 'pipeline',
  initialState,
  reducers: {
    setPipelineMobile: (state, action) => {
      const { pipelineMobile, pipelineMobileMap, sitePipelineCountMap } = action.payload || {};
      // state.pipelineMobile = action.payload;
      // state.pipelineMobileMap = action.payload.reduce((acc, curr, currIndex) => {
      //   acc[curr.pipelineId] = currIndex;
      //   return acc;
      // }, {});
      // const sitePipelineCountMap = getSiteAndPipelineCountMap({ pipelines: action.payload });
      // state.sitePipelineCountMap = sitePipelineCountMap;
      state.pipelineMobile = pipelineMobile;
      state.pipelineMobileMap = pipelineMobileMap;
      state.sitePipelineCountMap = sitePipelineCountMap;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

const pipelineReducer = pipelineSlice.reducer;

export const pipelineActions = pipelineSlice.actions;
export default pipelineReducer;

export const getSiteAndPipelineCountMap = ({ pipelines = [] }) => {
  let sitesStructureMap = {};

  for (let pipeline of pipelines) {
    const pipelineId = pipeline.pipelineId;
    const sites = pipeline?.sites || [];
    const fromSite = pipeline?.fromSite ? [pipeline?.fromSite] : [];
    const toSite = pipeline?.toSite ? [pipeline?.toSite] : [];
    const wells = pipeline?.wells || [];

    const sitesIds = Array.from(new Set([...sites, ...fromSite, ...toSite, ...wells])) || [];

    for (let siteId of sitesIds) {
      if (!sitesStructureMap[siteId]) sitesStructureMap[siteId] = [];
      sitesStructureMap[siteId].push(pipelineId);
    }
  }

  return sitesStructureMap;
};
